import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterGroupRbacRoleEntity } from './m-sfp-smart-filter-group-rbac-role.entity';
import { MSfpSmartFilterRbacRoleEntity } from './m-sfp-smart-filter-rbac-role.entity';
import { MoverGroupRbacRoleEntity } from './mover-group-rbac-role.entity';
import { MoverRbacRoleEntity } from './mover-rbac-role.entity';
import { PreferenceRbacRoleEntity } from './preference-rbac-role.entity';
import { RbacActionRoleEntity } from './rbac-action-role.entity';

@Index('_name', ['name'], { unique: true })
@Entity('_rbac_role')
export class RbacRoleEntity extends BaseEntity {
	@Column('varchar', { name: '_name', unique: true, length: 255 })
	public name!: string;

	@OneToMany(
		() => MoverRbacRoleEntity,
		(moverRbacRole) => moverRbacRole.fkRbacRole,
		{},
	)
	public moverRbacRoles!: Array<MoverRbacRoleEntity>;

	@OneToMany(
		() => MoverGroupRbacRoleEntity,
		(moverGroupRbacRole) => moverGroupRbacRole.fkRbacRole,
		{},
	)
	public moverGroupRbacRoles!: Array<MoverGroupRbacRoleEntity>;

	@OneToMany(
		() => PreferenceRbacRoleEntity,
		(preferenceRbacRole) => preferenceRbacRole.fkRbacRole,
		{},
	)
	public preferenceRbacRoles!: Array<PreferenceRbacRoleEntity>;

	@OneToMany(
		() => RbacActionRoleEntity,
		(rbacActionRole) => rbacActionRole.fkRbacRole,
		{},
	)
	public rbacActionRoles!: Array<RbacActionRoleEntity>;

	@OneToMany(
		() => MSfpSmartFilterRbacRoleEntity,
		(mSfpSmartFilterRbacRole) => mSfpSmartFilterRbacRole.fkRbacRole,
		{},
	)
	public mSfpSmartFilterRbacRoles!: Array<MSfpSmartFilterRbacRoleEntity>;

	@OneToMany(
		() => MSfpSmartFilterGroupRbacRoleEntity,
		(mSfpSmartFilterGroupRbacRole) => mSfpSmartFilterGroupRbacRole.fkRbacRole,
		{},
	)
	public mSfpSmartFilterGroupRbacRoles!: Array<MSfpSmartFilterGroupRbacRoleEntity>;
}
